import { styled } from "styled-components";

export const RecommendationCount = styled.span`
  margin-left: 16px;
`;
